export default {
	// Config
	apiKey: "AIzaSyB5buR1AEfDXexbhTPaGtksqcqPcKH4fYU",
  authDomain: "cremetech-mytrace.firebaseapp.com",
  projectId: "cremetech-mytrace",
  storageBucket: "cremetech-mytrace.firebasestorage.app",
  messagingSenderId: "126029672598",
  appId: "1:126029672598:web:dd1e404111b33c537e52b7"
};
